import './styles/templates/hoya.template.scss';

import GoBackComponent from './modules/go-back/go-back';
import ResourcesComponent from './modules/resources/resources';
import RelatedResources from './modules/related-resources/related-resources';
import ShareComponent from './modules/share/share';
import FollowComponent from './modules/follow/follow';

(function () {
  FollowComponent.init();
  GoBackComponent.init();
  ResourcesComponent.init();
  ShareComponent.init();
  RelatedResources.init();
})();
